import styled from 'styled-components';
import MuiCardContent from '@material-ui/core/CardContent';

export const StyledMuiCardContent = styled(MuiCardContent)`
  && {
    padding: 10px 30px;
    line-height: 24px;
  }
`;
